export default [
  {
    path: '/parametrizacao-template',
    component: {
      name: 'template',
      template: '<router-view />',
      meta: {
        resource: 'template',
        action: 'read',
        requiredAuth: true,
        breadcrumb: [
          { text: '', to: { path: '/' } },
        ],
      },
    },
    children: [{
      path: 'visualizar',
      name: 'template',
      component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/template/ParametrizacaoTemplate.vue'),
      meta: {
        resource: 'template',
        action: 'read',
        pageTitle: 'Template do contrato',
        breadcrumb: [
          {
            text: 'Templates',
            to: { name: 'template' },
            active: true,
          },
        ],
      },
    },
    {
      path: 'novo',
      name: 'novo-template',
      component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/components/cadastro-template/EditorCadastro.vue'),
      meta: {
        resource: 'template',
        action: 'create',
        requiredAuth: true,
        navActiveLink: 'template',
        pageTitle: 'Template do contrato',
        breadcrumb: [
          {
            text: 'Templates',
            to: { name: 'template' },
          },
          {
            text: 'Novo',
            to: { name: 'novo-template' },
            active: true,
          },
        ],
      },
    },
    {
      path: 'editar/:id',
      name: 'editar-template',
      component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/components/cadastro-template/EditorCadastro.vue'),
      meta: {
        resource: 'template',
        action: 'update',
        requiredAuth: true,
        navActiveLink: 'template',
        pageTitle: 'Template do contrato',
        breadcrumb: [
          {
            text: 'Templates',
            to: { name: 'template' },
          },
          {
            text: 'editar',
            to: { name: 'editar-template' },
            active: true,
          },
        ],
      },
    }],
  },
]
